export default __webpack_public_path__ + "static/media/norwaygo-screenshot-05.be3d8f63.png";